"use client"

import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Plus, Search, MessageSquare } from "lucide-react"
import { useRouter } from "next/navigation"

interface Thread {
  id: string
  title: string
  updatedAt: string
}

export function CompactThreads() {
  const [threads, setThreads] = useState<Thread[]>([])
  const [searchQuery, setSearchQuery] = useState("")
  const router = useRouter()

  // Mock threads for now - in real implementation, this would fetch from API
  useEffect(() => {
    setThreads([
      { id: "1", title: "Fitness routine help", updatedAt: "2024-01-10" },
      { id: "2", title: "Nutrition questions", updatedAt: "2024-01-09" },
      { id: "3", title: "Workout planning", updatedAt: "2024-01-08" },
    ])
  }, [])

  const filteredThreads = threads.filter(thread =>
    thread.title.toLowerCase().includes(searchQuery.toLowerCase())
  )

  const handleNewChat = () => {
    router.push("/chatbot")
  }

  const handleThreadClick = (threadId: string) => {
    router.push(`/chatbot?thread=${threadId}`)
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-muted-foreground">AI Chat</h3>
        <Button
          size="sm"
          variant="ghost"
          onClick={handleNewChat}
          className="h-6 w-6 p-0"
        >
          <Plus className="h-3 w-3" />
        </Button>
      </div>
      
      <div className="relative">
        <Search className="absolute left-2 top-1/2 h-3 w-3 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search chats..."
          value={searchQuery}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchQuery(e.target.value)}
          className="h-7 pl-7 text-xs"
        />
      </div>

      <div className="space-y-1 max-h-32 overflow-y-auto">
        {filteredThreads.map((thread) => (
          <button
            key={thread.id}
            onClick={() => handleThreadClick(thread.id)}
            className="w-full text-left p-2 rounded-md hover:bg-accent text-xs group transition-colors"
          >
            <div className="flex items-center gap-2">
              <MessageSquare className="h-3 w-3 text-muted-foreground" />
              <span className="truncate flex-1">{thread.title}</span>
            </div>
          </button>
        ))}
        {filteredThreads.length === 0 && (
          <div className="text-xs text-muted-foreground text-center py-2">
            No chats found
          </div>
        )}
      </div>
    </div>
  )
}